module.exports = __webpack_public_path__ + "img/jobmarket_process color logo.b2d53c31.png";